<template>
  <div style="height: 100%" class="histo">
    <v-card flat :height="chatHeight">
      <v-navigation-drawer
        v-if="navigation"
        v-show="listChats"
        v-model="listChats"
        class="contentListeHistoChats"
        enable-resize-watcher
        width="320"
        style="z-index: 1"
        light
        absolute
        persistent
        clipped
        hide-overlay
      >
        <v-toolbar flat class="white" dense extended>
          <v-toolbar-title>{{ $t('botHistory') }}</v-toolbar-title>
          <div v-if="visiteurs.length" slot="extension">
            {{ $tc('visitors', visiteurs.length, { count: visiteurs.length }) }}
            <v-btn 
              color="primary" 
              :loading="loadingExportChats"
              slot="activator" 
              :disabled="!visiteurs.length || loadingExportChats" 
              flat
              @click="exportAllChats({'view': false})"
            >
              exporter chats
              <!-- <v-icon color="primary" right>file_download</v-icon> -->
              <v-icon color="primary" right>visibility</v-icon>
            </v-btn>
          </div>
<!--           <div v-else-if="visiteurs.length && numChatsTotal >= 1500" slot="extension">
            {{ $tc('visitors', visiteurs.length, { count: visiteurs.length }) }}
            <v-btn 
              color="primary" 
              :loading="loadingExportChats"
              slot="activator" 
              :disabled="!visiteurs.length || loadingExportChats" 
              flat
              @click="exportAllChats({'view': true})"
            >
              exporter chats
              <v-icon color="primary" right>visibility</v-icon>
            </v-btn>
          </div> -->
          <div v-else class="subheading" slot="extension">{{ $tc('chats', 0) | cap }}</div>
        </v-toolbar>
        <v-divider></v-divider>

        <div class="listeChatsVisiteurs">
          <v-card v-if="loadingHisto">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>

          <v-list v-else two-line dense>
            <v-list-group v-for="visiteur in chatsSorted" :key="visiteur.visId" :value="visiteur.visId == visitorSelected">
              <!-- VISITEUR -->
              <v-list-tile
                slot="activator"
                ripple
                @click=";"
              >
                <v-list-tile-action>
                  <wz-avatar :username="'#' + visiteur.visId" size="35px"></wz-avatar>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ visiteur.visId }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ $tc('chats', visiteur.chats.length, { count: visiteur.chats.length }) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <!-- CHATS DU VISITEUR -->
              <v-list-tile
                v-for="chat in visiteur.chats"
                :key="chat.id"
                ripple
                @click="showChat(chat.id)"
                :class="{'grey lighten-2' : chat.id == chatId}"
              >
                <wz-avatar-double :avatars="[{id: visiteur.visId}, {id: chat.last.agentId, username: chat.last.agentName}]"></wz-avatar-double>
                <v-list-tile-content>
                  <!-- Nom du dernier auteur du chat -->
                  <v-list-tile-title>{{ chat.last.auteur == 'Visiteur' ? visiteur.visId : chat.last.agentName }}</v-list-tile-title>
                  <!-- Contenu du dernier message -->
                  <v-list-tile-sub-title>{{ chat.last.text }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <!-- Date du dernier message -->
                <v-list-tile-action>{{ chat.last.date }}</v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </div>

        <v-layout justify-center>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-pagination
                  v-model="pagination"
                  :length="calculTotalagination"
                  circle
                  :disabled="numChatsTotal <= 100"
                  @input="paginationInput(pagination)"
                ></v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-navigation-drawer>

      <v-toolbar 
        v-if="toolbar"
        class="primary"
        dark dense extended
        :class="{'histo__navigation--opened': listChats}"
      >
        <v-toolbar-side-icon v-if="navigation" @click.native="listChats = !listChats"></v-toolbar-side-icon>
        <v-toolbar-title v-if="chatId" class="white--text">#{{ visitorSelected }}</v-toolbar-title>
        <div v-if="chatSelected" class="white--text subheading" slot="extension">
          <v-tooltip right v-if="false">
            <span slot="activator" class="mr-3">
              <v-icon dark>access_time</v-icon>
              {{ chatSelected.duration }}
            </span>
            <span>Durée totale</span>
          </v-tooltip>
          <v-tooltip right v-if="false">
            <span slot="activator">
              <v-icon dark>timer</v-icon>
              {{ chatSelected.averageResponse }}
            </span>
            <span>{{ $t('chatsAverageResponse')}}</span>
          </v-tooltip>
          <span class="ml-2">
            {{ chatSelected.messages.length }}
            <v-icon dark right>chat_bubble_outline</v-icon>
          </span>
          <span class="ml-2" v-if="chatSelected.closed">
            {{ $t('closing') }} : {{ chatSelected.closed }}
            <v-icon dark right>offline_pin</v-icon>
          </span>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="chatSelected"
          icon="icon"
          :loading="loadingExportChat"
          :disabled="loadingExportChat" 
          @click="exportChat()"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </v-toolbar>

      <main
        :class="{
          'histo__navigation--opened vb': listChats,
          'histo__main--toolbar vb': toolbar,
          'histo__main--no-toolbar vb': !toolbar,
        }"
        ref="contentChat"
        id="contentChat"
        style="height: 100%;"
        v-bar
      >
        <div
          grid-list-sm
          fluid
          class="histo__main--scroll"
        >
          <v-card v-if="loading" :height="chatHeight">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>

          <div
            v-else-if="chatSelected"
            height="100%"
          >
            <transition name="slide-x-reverse-transition" mode="out-in">
              <v-layout row wrap   style="width: 100%;">
                <template v-for="(msg, i) in chatSelected.messages">
                  <!-- Indication du jour du chat -->
                  <v-flex xs12 v-if="msg.anotherDay" class="text-xs-center sticky" :key="msg.date">
                    <div secondary class="dateMessageChat">{{ msg.anotherDay }}</div>
                  </v-flex>
                  <v-flex xs12 :key="i">
                    <!-- message agent -->
                    <v-layout v-if="msg.auteur == 'Agent'" row>
                      <v-flex xs2 class="text-xs-right">
                        <wz-avatar :username="msg.agentName" :src="`${domaine}/media/user/small/${msg.agentId}_avatar.jpg`" size="35px"></wz-avatar>
                      </v-flex>
                      <v-flex xs10>
                        <v-card
                          :class="[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--agent',
                            colorChatAgent
                          ]"
                        >
                          <v-card-text class="pa-1">
                            <v-icon
                              v-if="false"
                              :color="colorChatAgent"
                              class="corner corner--agent"
                              unselectable="on"
                              onselectstart="return false;" 
                              onmousedown="return false;"
                            >arrow_drop_down</v-icon>
                            <div>
                              <span v-if="msg.text">{{ msg.text }}</span>
                              <img v-else :src="msg.attachment" alt="Image indisponible">
                            </div>
                            <small>{{ msg.type == '2' ? ' (auto)' : '' }}</small>
                          </v-card-text>
                        </v-card>
                        <small>{{ msg.agentName }} • {{ msg.date }}</small>
                      </v-flex>
                      <v-flex md3 class="hidden-sm-and-down"></v-flex>
                    </v-layout>
                    <!-- message visiteur -->
                    <v-layout v-else row>
                      <v-flex md3 class="hidden-sm-and-down"></v-flex>
                      <v-flex xs10 md8 class="text-xs-right">
                        <v-card
                          :class="['white--text', 'histo__bubble', 'histo__bubble--visitor', colorChatVisiteur]"
                        >
                          <v-card-text class="text-xs-right pa-1">
                            <v-icon
                              v-if="false"
                              :color="colorChatVisiteur"
                              class="corner corner--visitor"
                              unselectable="on"
                              onselectstart="return false;" 
                              onmousedown="return false;"
                            >arrow_drop_down</v-icon>
                            <div>
                              <span v-if="msg.text">{{ msg.text }}</span>
                              <img v-else :src="msg.attachment" alt="Image indisponible">
                            </div>
                          </v-card-text>
                        </v-card>
                        <small>{{ msg.date }}</small>
                      </v-flex>
                      <v-flex xs2>
                        <wz-avatar :username="'#' + visitorSelected" size="35px"></wz-avatar>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </template>
                <!-- Indication de la clôture du chat -->
                <v-layout v-if="chatSelected.closed">
                  <v-flex xs12 class="text-xs-center">
                    <v-chip
                      label
                      disabled
                      color="secondary"
                      text-color="white"
                    >
                      {{ $t('closing') }} : {{ chatSelected.closed }}
                      <v-icon right dark>offline_pin</v-icon>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-layout>
            </transition>
          </div>
          <v-alert v-else color="blue" icon="info" value="true" outline>
            {{ $tc('chats', 0) | cap }}
          </v-alert>
        </div>
      </main>
    </v-card>
  </div>
</template>

<style>
.histo__main--scroll {
  max-height: -webkit-fill-available;
}
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import json2csv from 'json2csv'
import { DOMAINE } from '../../constants'
export default {
  props: {
    params: {
      type: String,
      required: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    colorChatAgent: {
      type: String,
      default: 'teal'
    },
    colorChatVisiteur: {
      type: String,
      default: 'blue-grey darken-2'
    },
    chatHeight: {
      type: String,
      default: '600px'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    numChatsTotal: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      listChats: true,
      chatId: null,
      visiteurs: [],
      allChats: [],
      switchChat: false,
      loading: true,
      loadingHisto: false,
      loadingExportChats: false,
      loadingExportChat: false,
      pagination: 1,
      // paginationNumTotal: 1,
      indexPage: 1
    }
  },

  created () {
    this.loading = true
    this.loadingHisto = true
    // this.getChats(this.indexPage)
    this.listChats = this.navigation
    // this.paginationNumTotal = Math.ceil(this.numChatsTotal / 100)
    // si egale ou moins de 100 conversations alors il n'y a qu'une page dispo (je renvois un zero comme index de page)
    if (this.calculTotalagination) {
      this.getChats(1)
    } else {
      this.getChats(0)
    }
  },

  computed: {
    // calcule le nombre de pages dans la pagination
    calculTotalagination () {
      // console.log('this.numChatsTotal', this.numChatsTotal)
      if (Number(this.numChatsTotal) <= 100) {
        return 0
      } else {
        return Math.ceil(Number(this.numChatsTotal) / 100)
      }
    },

    chatSelected () {
      // recherche du chat lié au visiteur
      let chat = null
      _.each(this.visiteurs, vis => {
        if (!chat) {
          chat = _.find(vis.chats, {'id': this.chatId})
        }
      })
      if (!chat) return null
      // séparation des jours
      let prev = null
      chat.messages.map(msg => {
        let m = moment.unix(msg.unix)
        msg.anotherDay = m.format('LL')
        if (prev && moment(prev).isSame(m, 'day')) {
          msg.anotherDay = null
        }
        prev = m
      })
      chat.closed = chat.id.split('>')[1]
      chat.closed = chat.closed.length > 2
        ? moment.unix(chat.id.substring(chat.id.length - 13, chat.id.length - 3)).format('L LTS')
        : 0
      return chat
    },

    /**
     * Retourne la liste des chats
     * triés selon la date de leur dernier message
     * @return {Array}
     */
    chatsSorted () {
      return _.sortBy(this.visiteurs, [v => {
        // tri des chats/visiteur
        let sorted = _.sortBy(v.chats, [c => {
          return c.last.unix
        }]).reverse()
        // mise à jour des chats triés du visiteur parcouru
        v.chats = sorted
        return v.chats[0].last.unix
      }]).reverse()
    },

    /**
     * Retourne la liste des chats pour l'exportation CSV
     * triés selon la date de leur dernier message
     * @return {Array}
     */
    chatsSortedCSV () {
      return _.sortBy(this.allChats, [
        v => {
          // tri des chats/visiteur
          let sorted = _.sortBy(v.chats, [
            c => {
              return c.last.unix
            }
          ]).reverse()
          // mise à jour des chats triés du visiteur parcouru
          v.chats = sorted
          return v.chats[0].last.unix
        }
      ]).reverse()
    },

    visitorSelected () {
      return this.chatSelected
        ? this.chatSelected.id.split('>')[0]
        : null
    }
  },

  methods: {
    /**
     * Montre le détail du chat du visiteur choisi
     * et cache la liste si petit écran
     */
    showChat (id) {
      this.chatId = id
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.listChats = false
      }
    },

    paginationInput (page) {
      // console.log('paginationInput', page)
      // 650 c'est le nombre de bulle pour 100 conversations en moyenne
      this.indexPage = page
      // this.indexPage = page - 1
      this.getChats(this.indexPage)
    },

    /**
     * Recupère les chats selon les paramètres donnés
     */
    getChats (indexPage) {
      this.loadingHisto = true
      this.loading = true
      this.axios
        .get('get/bot_chats.php?' + this.params + '&indexPage=' + indexPage)
        .then(response => {
          // vide le tableau des visiteurs
          this.visiteurs = _.isArray(response.data) ? response.data : []
          _.each(this.visiteurs, visiteur => {
            visiteur.duration = moment.duration(visiteur.duration, 'seconds').format('h [h] m [m] s [s]')
            visiteur.averageResponse = moment.duration(visiteur.averageResponse, 'seconds').format('h [h] m [m] s [s]')
            // chaque conversation
            _.each(visiteur.chats, conversation => {
              // chaque message de la conversation
              _.each(conversation.messages, message => {
                if (message.text === 'undefined') message.text = null
                message.unix = message.date
                if (message.agentName === 'undefined' || message.agentName === '') {
                  let userFound = this.$store.getters['_User/getUserById'](message.agentId)
                  message.agentName = userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME
                }
                let date = moment.unix(message.unix)
                message.date = date.format('LTS')
                conversation.last = _.clone(message)
                conversation.last.date = date.calendar()
              })
            })
          })
          // Affichage par défaut du premier chat
          // du premier visiteur
          if (this.chatsSorted[0]) {
            this.showChat(this.chatsSorted[0].chats[0].id)
          }
        })
        .catch(errors => {
          this.loading = false
          this.loadingHisto = false
        })
        .then(_ => {
          this.loading = false
          this.loadingHisto = false
        })
    },

    /**
     * Exporter tous les chats
     */
    exportAllChats (data) {
      this.loadingExportChats = true
      this.axios
        .get('get/exportAllBotChatsCSV.php?' + this.params)
        .then(response => {
          console.log('response', response.data)
          if (response.data === 1) {
            this.loadingExportChats = false
            // ouvre une nouvelle page avec le contenu csv
            window.open('./static/viewCSV.php', '_blank')
          } else {
            console.log('pas fini')
          }
          // // vide le tableau des allChats
          // this.allChats = _.isArray(response.data) ? response.data : []
          // _.each(this.allChats, visiteur => {
          //   visiteur.duration = moment.duration(visiteur.duration, 'seconds').format('h [h] m [m] s [s]')
          //   visiteur.averageResponse = moment.duration(visiteur.averageResponse, 'seconds').format('h [h] m [m] s [s]')
          //   // chaque conversation
          //   _.each(visiteur.chats, conversation => {
          //     // chaque message de la conversation
          //     _.each(conversation.messages, message => {
          //       if (message.text === 'undefined') message.text = null
          //       message.unix = message.date
          //       if (message.agentName === 'undefined' || message.agentName === '') {
          //         let userFound = this.$store.getters['_User/getUserById'](message.agentId)
          //         message.agentName = userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME
          //       }
          //       let date = moment.unix(message.unix)
          //       message.date = date.format('LTS')
          //       conversation.last = _.clone(message)
          //       conversation.last.date = date.calendar()
          //     })
          //   })
          // })
        })
        .catch(errors => {
          this.loadingExportChats = false
        })
        .then(_ => {
          // si c'est ok on exporte en CSV
          // this.exportChats(data)
          // this.loadingExportChats = false
          // console.log('this.chatsSortedCSV', this.chatsSortedCSV)
        })
    },

    /**
     * Exporter tous les chats
     */
    exportChats (data) {
      let csv = null
      let fields = ['date', 'agentName', 'visiteur', 'auteur', 'text']
      let dataToExport = []
      _.each(this.chatsSortedCSV, vis => {
        _.each(vis.chats, chat => {
          let currentChat = chat.messages.map(m => {
            // console.log('m.agentName', m.agentName)
            return {
              'date': moment.unix(m.unix).format('LL') + ' ' + m.date,
              'visiteur': vis.visId,
              'agentName': m.agentName,
              'auteur': m.auteur,
              'text': m.text
            }
          })
          dataToExport.push(currentChat)
        })
      })
      try {
        csv = json2csv({
          data: _.flatten(dataToExport),
          del: ';',
          fields: fields
        })
      } catch (err) {
        console.err(err)
        this.loadingExportChats = false
        return
      }
      this.loadingExportChats = false
      // on telecharge
      if (!data.view) {
        this.downloadFile(csv)
      } else {
        // sinon on affiche
        this.$router.push({ name: 'viewcsv', params: { csv } })
      }
    },

    /**
     * Exporter un seul chat
     */
    exportChat () {
      this.loadingExportChat = true
      let csv = null
      let fields = ['date', 'agentName', 'visiteur', 'auteur', 'text']
      let id = this.visitorSelected
      // formatage
      let dataToExport = this.chatSelected.messages.map(m => {
        return {
          'date': moment.unix(m.unix).format('LL') + ' ' + m.date,
          'visiteur': id,
          'agentName': m.agentName,
          'auteur': m.auteur,
          'text': m.text
        }
      })
      try {
        csv = json2csv({
          data: dataToExport,
          del: ';',
          fields: fields
        })
      } catch (err) {
        console.err(err)
        this.loadingExportChat = false
        return
      }
      this.loadingExportChat = false
      this.downloadFile(csv)
    },

    /**
     * Télécharge un fihcier chez le client
     * @param  {String} fileContent contenu du fichier qui sera téléchargé
     */
    downloadFile (fileContent) {
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(fileContent)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },

    /**
     * Scroll jusque le bas du chat
     */
    scrollToBottom () {
      if (this.$refs.contentChat) {
        this.$refs.contentChat.scrollTo(0, this.$refs.contentChat.scrollHeight)
      }
    }
  },

  /**
   * A la mise à jour du rendu du composant
   * scroll tout en bas de l'historique du chat
   */
  updated () {
    this.$nextTick(() => {
      this.scrollToBottom()
    })
  },

  watch: {
    // au changement de filtres
    params (val, oldVal) {
      if (!_.endsWith(val, '=')) {
        // si egale ou moins de 100 conversations alors il n'y a qu'une page dispo (je renvois un zero comme index de page)
        if (this.calculTotalagination) {
          this.getChats(1)
        } else {
          this.getChats(0)
        }
      }
      // this.paginationNumTotal = Math.ceil(this.numChatsTotal / 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzHistoBot.vue